"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3404],{

/***/ 75229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kw": function() { return /* binding */ getLandbotApi; },
/* harmony export */   "Zt": function() { return /* binding */ searchModelsApi; }
/* harmony export */ });
/* unused harmony exports getPoliciesApi, getBlogPosts, getChiSiamoApi, getPressApi */
/* harmony import */ var src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49394);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91695);


var getPoliciesApi = function getPoliciesApi(slug) {
  return request.get("strapi/policies/".concat(slug));
};
var getLandbotApi = function getLandbotApi(code) {
  return src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("strapi/landbots/".concat(code));
};
var getBlogPosts = function getBlogPosts() {
  return request.get('https://blog.carplanner.com/rss.xml', {
    responseType: 'text'
  });
};
var getChiSiamoApi = function getChiSiamoApi() {
  return request.get('strapi/chi-siamo');
};
var getPressApi = function getPressApi() {
  return request.get('strapi/press-items');
};
var searchModelsApi = function searchModelsApi(path, term) {
  return src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("".concat(_constants__WEBPACK_IMPORTED_MODULE_1__/* .OFFERS_EXPLORER_SERVICE_URI */ .PT, "/").concat(path), {
    term: term
  });
};

/***/ }),

/***/ 28641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39653);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20979);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83292);
/* harmony import */ var _choc_ui_chakra_autocomplete__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59891);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3382);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37930);
/* harmony import */ var server_api_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75229);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);



var _excluded = ["items", "apiPath", "onSelect", "placeholder", "notFoundText", "withOverlay", "disableFilter", "resultFormatter"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var Autocomplete = function Autocomplete(_ref) {
  var items = _ref.items,
      apiPath = _ref.apiPath,
      onSelect = _ref.onSelect,
      placeholder = _ref.placeholder,
      notFoundText = _ref.notFoundText,
      withOverlay = _ref.withOverlay,
      disableFilter = _ref.disableFilter,
      resultFormatter = _ref.resultFormatter,
      styleProps = (0,_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref, _excluded);

  var _useDisclosure = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .useDisclosure */ .qY)(),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var searchInputElement = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
  var modalClosedFocusRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      searchTerm = _useState[0],
      setSearchTerm = _useState[1];

  var itemsRepo = apiPath ? searchTerm : items;
  var searchInputChangeHandler = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(target) {
      var value, found;
      return _codebuild_output_src3615454741_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              value = target.value;

              if (!(apiPath && value.length >= MIN_STRING_LENGTH)) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return (0,server_api_common__WEBPACK_IMPORTED_MODULE_5__/* .searchModelsApi */ .Zt)(apiPath, value);

            case 4:
              found = _context.sent;

              if (found && found.data) {
                itemsRepo = found.data.map(resultFormatter || function (_ref3) {
                  var name = _ref3.name,
                      code = _ref3.code;
                  return {
                    label: name,
                    value: code
                  };
                });
              }

              setSearchTerm(itemsRepo);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var MIN_STRING_LENGTH = 2;

  var searchInputFocusHandler = function searchInputFocusHandler() {
    if (withOverlay) {
      if (searchInputElement && searchInputElement.current) {
        searchInputElement.current.style.zIndex = '1401'; // modal z-index + 1
      }

      onOpen();
    }
  };

  var onModalClose = function onModalClose() {
    if (withOverlay) {
      if (searchInputElement && searchInputElement.current) {
        searchInputElement.current.style.zIndex = '1';
      }

      onClose();
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .InputGroup */ .BZ, _objectSpread(_objectSpread({
      size: "lg",
      display: "block",
      ref: searchInputElement,
      onFocus: searchInputFocusHandler,
      borderColor: src_themes__WEBPACK_IMPORTED_MODULE_4__/* .theme.colors.borders.grey */ .r.colors.borders.grey,
      className: "searchAutoComplete"
    }, styleProps), {}, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_choc_ui_chakra_autocomplete__WEBPACK_IMPORTED_MODULE_3__/* .AutoComplete */ .Qc, {
        onChange: onSelect,
        emptyState: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("em", {
          children: notFoundText || ''
        }),
        filter: disableFilter ? function () {
          return true;
        } : null,
        shouldRenderSuggestions: function shouldRenderSuggestions(value) {
          return value.length >= MIN_STRING_LENGTH;
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_choc_ui_chakra_autocomplete__WEBPACK_IMPORTED_MODULE_3__/* .AutoCompleteInput */ .Vp, {
          size: "lg",
          placeholder: placeholder,
          borderRadius: "4px",
          className: "auto-complete-input",
          onChange: function onChange(_ref4) {
            var target = _ref4.target;
            return searchInputChangeHandler(target);
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_choc_ui_chakra_autocomplete__WEBPACK_IMPORTED_MODULE_3__/* .AutoCompleteList */ .Jm, {
          borderRadius: "4px",
          mt: "0",
          maxWidth: "100%",
          children: itemsRepo.map(function (item) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_choc_ui_chakra_autocomplete__WEBPACK_IMPORTED_MODULE_3__/* .AutoCompleteItem */ .Gb, {
              value: item.value,
              label: "".concat(item.label),
              textAlign: "left",
              children: "".concat(item.label.substring(0, 70), "\u2026")
            }, "option-".concat(item.value));
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .InputRightElement */ .xH, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_11__/* .SearchIcon */ .W1, {
          color: "baseNeutral.400"
        })
      })]
    })), withOverlay && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Modal */ .u_, {
      isOpen: isOpen,
      onClose: onModalClose,
      trapFocus: false,
      finalFocusRef: modalClosedFocusRef,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .ModalOverlay */ .ZA, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .ModalContent */ .hz, {
        display: "none",
        top: "-1000px",
        left: "-1000px"
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Autocomplete);

/***/ })

}]);